import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IDeleteDataRolesParams {
  ids: string[];
}

export interface IDeleteDataRolesResult extends IResult {
}

export class DeleteDataRolesRequest extends Request<IDeleteDataRolesParams, IDeleteDataRolesResult> {
  constructor(ids: string[]) {
    super('deleteDataRoles', { ids: ids });
  }
}
